"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "DownloadPdf___StyledSvg",
  componentId: "kmas9t-0"
})(["color:", ";height:", ";width:", ";font-size:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
});

function DownloadPdf(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size,
    _css4: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 5l-3-3H6a1 1 0 00-1 1v14a1 1 0 001 1h11a1 1 0 001-1V5zm-4-2v3h3v11H6V3h8z",
    fill: "#707070"
  }), _react["default"].createElement("rect", {
    x: 2,
    y: 6,
    width: 11,
    height: 10,
    rx: 1,
    fill: "#BD0100"
  }), _react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.082 9.524c.055 0 .055 0 0 0 .055-.225.112-.338.112-.506v-.113c.055-.285.055-.51 0-.566v-.057l-.057-.055s0 .055-.055.055c-.113.338-.113.736 0 1.242zM5.4 13.42a1.246 1.246 0 00-.279.168c-.39.34-.672.737-.727.905.336-.056.673-.394 1.006-1.073.057 0 .057 0 0 0 0 0 .057 0 0 0zm5.155-.846c-.058-.058-.282-.226-1.067-.226h-.11v.055c.391.171.783.284 1.064.284h.167v-.058s-.054 0-.054-.055zm.224.452a1.126 1.126 0 01-.506.114 3.99 3.99 0 01-1.679-.398c-.952.113-1.682.226-2.24.453-.057 0-.057 0-.112.057C5.57 14.438 5.01 15 4.561 15c-.112 0-.167 0-.224-.055l-.28-.168v-.058C4 14.606 4 14.551 4 14.438c.057-.284.394-.792 1.067-1.186.112-.057.278-.17.502-.284.168-.28.337-.62.561-1.014.28-.566.449-1.13.615-1.638-.224-.678-.336-1.075-.112-1.864.055-.225.224-.452.45-.452h.111c.112 0 .224.055.336.113.391.394.225 1.299 0 2.032v.058c.225.62.558 1.128.895 1.467.17.113.281.226.505.339.28 0 .503-.055.727-.055.673 0 1.122.11 1.288.394.055.113.055.226.055.34-.055.054-.112.225-.221.338zm-3.642-2.203c-.112.395-.337.847-.558 1.354-.112.226-.224.397-.337.623h.113c.727-.284 1.4-.452 1.845-.51-.112-.055-.167-.113-.221-.168-.282-.339-.618-.791-.842-1.299z",
    fill: "#fff"
  }));
}

var _default = DownloadPdf;
exports["default"] = _default;